import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { PERMISSIONS } from "helpers/roles"
import UsersTable from "pages/Users/table"
import RolesTable from "pages/Roles/table"
import { usePermission } from "hooks/usePermission"

const UserMangement = () => {
  const tabs = ["USER", "ROLE"]
  const { permissions } = useSelector((state) => state.user)
  const [activeTab, setActiveTab] = useState()
  const navigate = useNavigate()
  const { hasPermission } = usePermission()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.some((perm) =>
        [PERMISSIONS.USER_LIST, PERMISSIONS.ROLE_LIST].includes(perm)
      )
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "").toUpperCase()
      if (tabs.includes(hash)) {
        setActiveTab(hash)
      } else {
        const perm = hasPermission(PERMISSIONS.USER_LIST) ? "USER" : "ROLE"
        setActiveTab(perm)
        window.location.hash = perm
      }
    }

    handleHashChange()
    window.addEventListener("hashchange", handleHashChange)

    return () => window.removeEventListener("hashchange", handleHashChange)
  }, [permissions])

  const HeaderComponent = () => (
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 justify-content-between">
      <div className="investment-trends-tab-section mb-3">
        {hasPermission(PERMISSIONS.USER_LIST) && (
          <div onClick={() => setActiveTab("USER")} className="tab-box">
            <p
              className={activeTab === "USER" ? "active" : ""}
              style={{ minWidth: "100px" }}
            >
              Users
            </p>
          </div>
        )}

        {hasPermission(PERMISSIONS.ROLE_LIST) && (
          <div onClick={() => setActiveTab("ROLE")} className="tab-box">
            <p
              className={activeTab === "ROLE" ? "active" : ""}
              style={{ minWidth: "100px" }}
            >
              Roles
            </p>
          </div>
        )}
      </div>
    </div>
  )

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={activeTab === "USER" ? "Users" : "Roles"} />
          {activeTab === "USER" && (
            <UsersTable HeaderComponent={HeaderComponent} />
          )}
          {activeTab === "ROLE" && (
            <RolesTable HeaderComponent={HeaderComponent} />
          )}
        </Container>
      </div>
    </>
  )
}

export default UserMangement
